export const helloSignErrors = {
  network_error: 'Lost connectivity',
  credentials_required: 'Login required',
  verify_email: 'Verify email step for template links',
  not_found: 'Resource not found',
  signer_choice: 'Must specify which signer they are',
  no_valid_signature_types: 'No signature type allowed due to settings',
  server_error: 'Generic server error',
  access_code_required: 'Must enter access code',
  access_code_invalid: 'Access code entered is invalid',
  access_code_blocked: 'Invalid access code entered too many times',
  nothing_to_sign: 'Nothing to sign or already signed',
  bad_request: 'Invalid request parameter(s)',
  bad_method: 'Unexpected HTTP method',
  unknown: 'Unknown exception'
}

export enum accountingErrors {
  NO_ACCOUNTS = 'NO_ACCOUNTS',
  NO_ACCOUNTING_DATA = 'NO_ACCOUNTING_DATA'
}
